__turbopack_context__.v({
  "arrow": "LoadSummaryChip-module-scss-module__7AEENW__arrow",
  "bodyArrow": "LoadSummaryChip-module-scss-module__7AEENW__bodyArrow",
  "bodyChip": "LoadSummaryChip-module-scss-module__7AEENW__bodyChip",
  "bodyRoute": "LoadSummaryChip-module-scss-module__7AEENW__bodyRoute",
  "bodySpecs": "LoadSummaryChip-module-scss-module__7AEENW__bodySpecs",
  "bodyStacked": "LoadSummaryChip-module-scss-module__7AEENW__bodyStacked",
  "chip": "LoadSummaryChip-module-scss-module__7AEENW__chip",
  "chipHero": "LoadSummaryChip-module-scss-module__7AEENW__chipHero",
  "city": "LoadSummaryChip-module-scss-module__7AEENW__city",
  "dot": "LoadSummaryChip-module-scss-module__7AEENW__dot",
  "hpv2Blink": "LoadSummaryChip-module-scss-module__7AEENW__hpv2Blink",
  "hpv2DemoBounce": "LoadSummaryChip-module-scss-module__7AEENW__hpv2DemoBounce",
  "hpv2DemoFadeIn": "LoadSummaryChip-module-scss-module__7AEENW__hpv2DemoFadeIn",
  "hpv2DemoProgress": "LoadSummaryChip-module-scss-module__7AEENW__hpv2DemoProgress",
  "hpv2DemoScaleIn": "LoadSummaryChip-module-scss-module__7AEENW__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "LoadSummaryChip-module-scss-module__7AEENW__hpv2DemoSlideIn",
  "hpv2FadeLeft": "LoadSummaryChip-module-scss-module__7AEENW__hpv2FadeLeft",
  "hpv2FadeRight": "LoadSummaryChip-module-scss-module__7AEENW__hpv2FadeRight",
  "hpv2FadeUp": "LoadSummaryChip-module-scss-module__7AEENW__hpv2FadeUp",
  "hpv2FloatA": "LoadSummaryChip-module-scss-module__7AEENW__hpv2FloatA",
  "hpv2FloatB": "LoadSummaryChip-module-scss-module__7AEENW__hpv2FloatB",
  "hpv2HeroFadeIn": "LoadSummaryChip-module-scss-module__7AEENW__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "LoadSummaryChip-module-scss-module__7AEENW__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "LoadSummaryChip-module-scss-module__7AEENW__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "LoadSummaryChip-module-scss-module__7AEENW__hpv2PriceShimmer",
  "hpv2PulseDot": "LoadSummaryChip-module-scss-module__7AEENW__hpv2PulseDot",
  "hpv2ScaleUp": "LoadSummaryChip-module-scss-module__7AEENW__hpv2ScaleUp",
  "loadingTime": "LoadSummaryChip-module-scss-module__7AEENW__loadingTime",
  "meta": "LoadSummaryChip-module-scss-module__7AEENW__meta",
  "separator": "LoadSummaryChip-module-scss-module__7AEENW__separator",
  "timeRow": "LoadSummaryChip-module-scss-module__7AEENW__timeRow",
  "top": "LoadSummaryChip-module-scss-module__7AEENW__top",
});
